import Vue from 'vue'
import './plugins/axios'
import './plugins/userback'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import fontawsome from './plugins/fontawsome'
import i18n from './i18n'
import VueApexCharts from 'vue-apexcharts'
import Avataaars from 'vuejs-avataaars'
import * as filters from './plugins/filters'
import VueClipboard from 'vue-clipboard2'
import VueGtag from 'vue-gtag'
import VueWamp from 'vue-wamp'
import * as Sentry from '@sentry/vue'
import { logEvent } from '@/utils'
import { VueFunnelGraph } from 'vue-funnel-graph-js'
import '@/styles/global.scss'
import VueTour from 'vue-tour'
import YzComponents from './plugins/yzcomponents'
require('vue-tour/dist/vue-tour.css')

Vue.config.productionTip = false
Vue.use(VueTour)
Vue.use(YzComponents)

// Register third-party components
Vue.component('apexchart', VueApexCharts)
Vue.component('avataaars', Avataaars)
Vue.component('vue-funnel-graph', VueFunnelGraph)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueGtag, {
  config: {
    config: { id: 'UA-161700048-2' }
  }
})
Vue.use(VueWamp, {
  url: process.env.VUE_APP_WS_URL,
  realm: process.env.VUE_APP_WS_REALM
})

Vue.prototype.$subdomain = null
Vue.prototype.$isMobile = false
if (window.location.hostname.includes(`.${process.env.VUE_APP_BASE_DOMAIN}`)) {
  let subdomain = window.location.hostname.split('.')[0]
  Vue.prototype.$subdomain = subdomain
  Vue.prototype.$isLandingPage = subdomain === 'www' || subdomain === 'app'
} else {
  Vue.prototype.$subdomain = ''
  Vue.prototype.$isLandingPage = false
}

Vue.prototype.$logEvent = logEvent
Vue.prototype.$theme = 'light'
Vue.prototype.$currency = store.getters['getCompanyCurrency']

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

if (process.env.VUE_APP_ENV === 'test') {
  Sentry.init({
    dsn: 'https://696fbb64294c2f8895b77fd87daa08a9@sentry.yezza.xyz/3',
    environment: process.env.VUE_APP_ENV,
    send_default_pii: true,
    Vue: Vue,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    trackComponents: true,
    tracesSampleRate: 0.01,
    tracePropagationTargets: ['localhost', process.env.VUE_APP_BASE_URL],
    replaysSessionSampleRate: 0.005,
    replaysOnErrorSampleRate: 0.1,
  })
} else {
  Sentry.init({
    dsn: 'https://9e3c8d291be74abaa43f36bf98b1f947@sentry.arbatravel.com/17',
    environment: process.env.VUE_APP_ENV,
    send_default_pii: true,
    Vue: Vue
  })
}

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration)
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError)
      })
  })
}

new Vue({
  router,
  store,
  vuetify,
  fontawsome,
  i18n,
  render: h => h(App)
}).$mount('#app')